import { NgClass } from '@angular/common';
import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'primeng/api';
import { Menu, MenuModule } from 'primeng/menu';
import { Subject, forkJoin, takeUntil } from 'rxjs';
import { CignaIconComponent } from '../../../shared/components/cigna-icon/cigna-icon.component';
import { StorageKeys } from '../../../shared/enums/storage-keys.enum';
import { UrlKeys } from '../../../shared/enums/urls.enum';
import { InsuredData, UserData } from '../../../shared/models/user-data';
import { ApiPrivateService } from '../../../shared/services/api-private.service';
import { AuthService } from '../../../shared/services/auth.service';
import { ConsoleService } from '../../../shared/services/console.service';
import { StorageDataService } from '../../../shared/services/storage-data.service';
import { StorageService } from '../../../shared/services/storage.service';
import { UtilsService } from '../../../shared/services/utils.service';

@Component({
  selector: 'app-insured-dropdown',
  templateUrl: './insured-dropdown.component.html',
  standalone: true,
  imports: [NgClass, CignaIconComponent, MenuModule, SharedModule, TranslateModule],
})
export class InsuredDropdownComponent implements OnInit, OnDestroy {
  @Output() authorizedClicked = new EventEmitter<boolean>();
  @ViewChild('menu5') menu!: Menu;

  private _apiPrivateService = inject(ApiPrivateService);
  private _authService = inject(AuthService);
  private _consoleService = inject(ConsoleService);
  private _router = inject(Router);
  private _storageDataService = inject(StorageDataService);
  private _storageService = inject(StorageService);
  private _utilsService = inject(UtilsService);

  logged: boolean = false;
  itemsAuthorized: UserData[] = [];
  isAuthorized: boolean = true;
  iniciales: string = '';
  inicialesfam1: string = '';
  inicialesfam2: string = '';
  inicialesfam3: string = '';
  count: number = 0;
  showMenu: boolean = false;
  showCover: boolean = false;
  logData!: InsuredData;
  menuOpcion: { [key: string]: boolean } = {};

  selectedAuthorized!: UserData;
  closed: boolean = true;
  private readonly destroySubject$ = new Subject<void>();

  ngOnInit(): void {
    this._authService.logged$.subscribe((val: boolean) => {
      if (this.logged !== val) {
        this.logged = val;
        this.getHomeData();
      }
    });
    this.getHomeData();
  }

  ngOnDestroy(): void {
    this.destroySubject$.next();
  }

  reload(event: Event): void {
    const trigger = event.currentTarget as HTMLElement;

    if (this.closed) {
      const openMenu = (): void => {
        this.closed = false;
        this.menu.show(event);
        this.getHomeData();
        trigger?.blur();
      };

      if (!this._utilsService.isSimulating()) {
        forkJoin([
          this._apiPrivateService.getHome(),
          this._apiPrivateService.getAuthorized(),
        ]).subscribe(res => {
          //const userData: UserData = res[0];
          const userData: UserData = this._storageService.sessionStorageGetItem(StorageKeys.LOGIN_DATA);
          const insuredData: InsuredData = res[1];
          this._storageService.sessionStorageSetItem(StorageKeys.LOGIN_DATA, {
            ...userData,
            authorized: insuredData.authorized,
          });
          openMenu();
        });
      } else {
        openMenu();
      }
    } else {
      this.closed = true;
      this.menu.hide();
      trigger?.blur();
    }
  }

  closeWithCover(): void {
    this.closed = true;
    this.menu.hide();
  }

  getHomeData(): void {
    this._consoleService.log('[insuredDropdown] getHomeData');
    this.logData = this._storageService.sessionStorageGetItem(StorageKeys.LOGIN_DATA);
    this.itemsAuthorized = this.logData.authorized;
    this._storageDataService.selectedAuthorized$
      .pipe(takeUntil(this.destroySubject$))
      .subscribe(selected => {
        this.selectedAuthorized = selected!;
        this.initIniciales();
      });
  }

  getTitle(): string {
    return this.selectedAuthorized?.fullName
      ? this.ordenarNombre(this.selectedAuthorized.fullName)
      : 'headerLog.select';
  }

  private initIniciales(): void {
    this.iniciales = this.obtenerIniciales(this.logData.fullName);

    this.inicialesfam1 = '';
    this.inicialesfam2 = '';
    this.inicialesfam3 = '';
    for (this.count = 0; this.count < this.logData.authorized?.length; this.count++) {
      if (this.count == 0) {
        this.inicialesfam1 = this.obtenerIniciales(this.logData.authorized[this.count].fullName);
      } else if (this.count == 1) {
        this.inicialesfam2 = this.inicialesfam1;
        this.inicialesfam1 = this.obtenerIniciales(this.logData.authorized[this.count].fullName);
      } else if (this.count == 2) {
        this.inicialesfam3 = this.inicialesfam2;
        this.inicialesfam2 = this.inicialesfam1;
        this.inicialesfam1 = this.obtenerIniciales(this.logData.authorized[this.count].fullName);
      }
    }
  }

  obtenerIniciales(fullName: string): string {
    return this._utilsService.iniciales(fullName);
  }

  ordenarNombre(fullName: string): string {
    return this._utilsService.nombreMinusculas(fullName);
  }

  selectAuthorized(authorized: UserData): void {
    if (authorized.isAuthorized) {
      this._storageDataService.setAuthorized(authorized);
      this.authorizedClicked.emit(true);
      this._router.navigate([`/${UrlKeys.MI_CIGNA}`]);
    }
  }

  openMenu(opcion: string): void {
    this.showCover = true;
    this.menuOpcion[opcion] = true;
  }

  closeMenu(opcion: string): void {
    this.showCover = false;
    this.menuOpcion[opcion] = false;
  }
}
